// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store/index'
import iView from 'iview'
import * as util from "@/util/util"
import * as WBT from '@/util/websocket'
import 'vue2-animate/dist/vue2-animate.css';
import 'iview/dist/styles/iview.css';
import 'font-awesome/css/font-awesome.css'
import '../static/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App';
import router from './router';
import req from '@/util/req';
import storage from '@/store/storage'
import '../static/css/pingfangfont.css';
import '../static/css/dialog.css';
import { operationType } from "@/config/config";
import expand from '@/components/table/expand'
Vue.component('expand', expand)
import tablePage from '@/components/table/page'
Vue.component('tablePage', tablePage)
import selectTree from '@/components/elSelect/selectTree'
Vue.component('selectTree', selectTree)
import hotelmap from "./components/map/Hotelmap"
Vue.component('hotelmap', hotelmap)
import searchmap from "./components/map/Searchmap"
Vue.component('searchmap', searchmap)
import gdmap from "./components/map/GDmap"
Vue.component('gdmap', gdmap)
// 详情引入
import GDmapDetail from "./components/map/GDmapDetail"
Vue.component('GDmapDetail', GDmapDetail)
import gdenclosure from "./components/map/GDenclosure"
Vue.component('gdenclosure', gdenclosure)
import realPlay from "@/components/vueAliplayerV2/realPlay";
Vue.component('realPlay', realPlay)

//My
import Axios from 'axios';
import Qs from 'qs';

// Axios.defaults.baseURL = "/api";
Axios.defaults.baseURL = "http://sy.sdsg.cn/";    //正式
// Axios.defaults.baseURL = "http://47.110.158.222/";    //测试
// Axios.defaults.baseURL = 'https://sy.lipp.com.cn/trsyb';

Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.Auth = JSON.parse(localStorage.getItem('tr_Auth')).token;
  if (config.method === 'post') {
    // post请求
    let data = {}
    if (config.data) {
      data = Qs.parse(config.data)
    }
    config.data = Qs.stringify(data)
  }
  return config;
}, function (error) {
// 对请求错误做些什么
    return Promise.reject(error);
});

Object.defineProperty(Vue.prototype, '$axios', {
	get() {
		return Axios;
	}
});

// import hlsVideo from "@/components/vueAliplayerV2/videoPlayer";
// Vue.component('hlsVideo', hlsVideo)

let na = navigator.userAgent;
if(/MSIE/i.test(na) || "ActiveXObject" in window){
  console.log('IE浏览器');
}else{
  Vue.component(
    'hlsVideo',
    // 这个动态导入会返回一个 `Promise` 对象。
    () => import('@/components/vueAliplayerV2/videoPlayer')
  )
  console.log('其他浏览器')
}

import VueAliplayerV2 from 'vue-aliplayer-v2';
Vue.use(VueAliplayerV2);
import 'babel-polyfill'
import Video from 'video.js'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import videoPlayer from "vue-video-player"
Vue.use(videoPlayer);
import 'videojs-flash'

Vue.prototype.$video = Video

Vue.use(iView);
Vue.config.productionTip = false
Vue.prototype.$util = util;
Vue.prototype.$storage = storage;
Vue.prototype.$req = req;
Vue.prototype.$operationType = operationType;
Vue.prototype.$WBT = WBT;
Vue.prototype.$menuConfig = window.globle.menuConfig;
Vue.prototype.$store = store;

Vue.prototype.setTableMaxHeight = function () { //设置表格的最大高度
  var height = document.getElementById("manage").clientHeight;
  var conditionHeight = document.getElementsByClassName("condition")[0]
    .clientHeight; //条件框高度
  var marginBottom = 12; //筛选条件和表格的距离
  var pageHeight = 42; //分页的高度
  return height - conditionHeight - marginBottom - pageHeight;
}

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import {
  PageHeader,
  Checkbox,
  CheckboxGroup,
  Cascader,
  Radio,
  RadioGroup,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Row,
  Col,
  Pagination,
  Dialog,
  Button,
  Input,
  Table,
  TableColumn,
  Form,
  FormItem,
  Dropdown,
  Breadcrumb,
  BreadcrumbItem,
  Autocomplete,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  MessageBox,
  Message,
  Loading,
  Notification,
  DatePicker,
  TimeSelect,
  TimePicker,
  Tabs,
  Select,
  Option,
  OptionGroup,
  TabPane,
  Tooltip,
  Progress,
  Carousel,
  CarouselItem,
  Upload,
  Popover,
  Tag,
  Tree,
  Image,
  Scrollbar,
  Steps,
  Step,
  Divider,
  Alert,
  Collapse,
  CollapseItem,
  Slider
} from 'element-ui'
Vue.use(Slider)
Vue.use(CollapseItem)
Vue.use(Collapse)
Vue.use(PageHeader)
Vue.use(Scrollbar)
Vue.use(Checkbox)
Vue.use(Steps)
Vue.use(Step)
Vue.use(CheckboxGroup)
Vue.use(Cascader)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Tag)
Vue.use(Popover)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Form)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(FormItem)
Vue.use(Dropdown)
Vue.use(Autocomplete)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Loading.directive)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Popover)
Vue.use(Tag)
Vue.use(Tree)
Vue.use(Image)
Vue.use(Divider)
Vue.use(Alert)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js